export const contactsData = {
    email: 'official.bigyama@gmail.com',
    phone: '+9779860168600',
    address: 'Gongabu, Kathmandu, Nepal',

    sheetAPI: ''
}